<template>
  <div style="display: inline-flex; align-items: center;">
    <b-btn
      v-b-tooltip.hover
      title="Visualizar Última Declaração PGDAS-D 2018"
      variant="none"
      class="btn-actions p-0"
      style="margin-right: 3px;"
      @click="abrirArquivo(gridProps.row)"
    >
      <font-awesome-icon
        icon="fa-sharp fa-regular fa-clipboard"
        class="text-primary"
        style="font-size:1.3rem !important;width:22px"
      />
    </b-btn>

    <b-btn
      v-b-tooltip.hover
      title="Histórico do Sublimite"
      variant="none"
      class="btn-actions p-0"
      style="margin-right: 3px;"
      @click="openModalHistorico(gridProps)"
    >
      <font-awesome-icon
        icon="fa-sharp fa-solid fa-list"
        class="text-primary"
        style="font-size:1.3rem !important;width:22px"
      />
    </b-btn>

    <b-btn
      v-b-tooltip.hover
      title="Enviar por e-mail"
      variant="none"
      class="btn-actions p-0"
      style="margin-right: 3px;"
      @click="openModalEnviarSublimite()"
    >
      <feather-icon
        icon="SendIcon"
        class="text-primary"
        size="20"
      />
    </b-btn>

    <b-btn
      v-b-tooltip.hover
      title="Observações"
      variant="none"
      class="btn-actions p-0"
      style="margin-right: 3px;"
      @click="openModalObservacao()"
    >
      <font-awesome-icon
        icon="fa-regular fa-message"
        :class="{
          'text-success': todasObservacoesLidas,
          'text-warning': !todasObservacoesLidas && temObservacaoNova,
          'text-primary': !todasObservacoesLidas && !temObservacaoNova,
        }"
        style="font-size:1.3rem !important;width:22px"
      />
    </b-btn>

    <modal-whatsapp
      tipo-rotina="Sublimite"
      :row="gridProps.row"
      :api="apiWhatsapp"
    />

    <modal-observacao
      ref="modalObservacao"
      v-model="gridProps.row"
      tipo="Sublimite"
      :api="apiHistorico"
      :notificar="{ sucesso: notficarSucesso, erro: notificarErro }"
      @hidden="fecharObservacao($event)"
    />

    <visualizar-arquivo
      v-if="mostarArquivo && arquivo.url"
      :url="arquivo.url"
      @hidden="fecharArquivo()"
    />

    <envio-email
      ref="modalEnvioEmail"
      :title="`Enviar Sublimite ${gridProps.row.razaoSocial}`"
      :sugestao="gridProps.row.emailEmpresa"
      :sugestao-email-adicional="gridProps.row.emailAdicionalEmpresa"
      @enviarEmail="enviarSublimite"
    />

    <modal-historico
      :ref="`modalHistorico${gridProps.row.id}`"
      rotina="Sublimite"
      tipo="Sublimite"
      :empresa="gridProps.row"
      :api="apiHistorico"
      :coluna-historico="colunaHistorico"
      :filtro-by-historico="['Competencia']"
      :acoes-lote="{ downloadLote: false, enviarEmail: false, downloadExcel: false, enviarWhatsApp: false }"
      :acaos-individuais="{ download: true, enviarEmail: true, enviarWhatsApp: true, observacao: true }"
    />
  </div>
</template>

<style lang="scss">
.acoes-usuario {
  margin-right: 0.3rem;
  padding: 0.4rem;
}
</style>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// import envioHistoricoApi from '@app/shared/services/envio-historico-api'
import colunasHistorico from '../historico'
import api from '../../services/api'

export default {
  components: {
    FontAwesomeIcon,
    VisualizarArquivo: () => import('@pilar/components/visualizar-arquivo/VisualizarArquivo.vue'),
    EnvioEmail: () => import('@/app/shared/components/envio-email/EnvioEmail.vue'),
    ModalWhatsapp: () => import('@/app/shared/components/whatsapp/ModalWhatsapp.vue'),
    ModalHistorico: () => import('@/app/shared/components/historico/ModalHistorico.vue'),
    ModalObservacao: () => import('@/app/shared/components/modal-observacao/ModalObservacao.vue'),
  },
  props: {
    gridProps: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mostarArquivo: false,
      arquivo: {},
      docSelecionado: null,
      apiWhatsapp: api,
      apiHistorico: api,
      colunaHistorico: colunasHistorico,
    }
  },
  computed: {
    temObservacaoNova() {
      return this.gridProps?.row?.temObservacoesNaoLidas ?? false
    },
    todasObservacoesLidas() {
      return this.gridProps?.row?.todasObservacoesLidas ?? false
    },
  },
  methods: {
    abrirArquivo(documento) {
      this.docSelecionado = documento
      api.getURL(documento.id)
        .then(payload => {
          this.arquivo.url = payload.data
          this.mostarArquivo = true
        })
        .catch(err => {
          this.fecharArquivo()
          this.notificarErro('Não foi possível abrir a visualização de arquivo.')
          throw err
        })
    },
    fecharArquivo() {
      this.mostarArquivo = false
      this.docSelecionado = null
      this.arquivo = {}
    },
    notificarErro(msg) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: msg,
          icon: 'fa-solid fa-circle-exclamation',
          variant: 'danger',
        },
      })
    },
    notficarSucesso(msg) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: msg,
          icon: 'fa-solid fa-circle-check',
          variant: 'success',
        },
      })
    },
    openModalEnviarSublimite() {
      this.$refs.modalEnvioEmail.abrirModal()
    },
    enviarSublimite(itens) {
      if (itens.emailsPara.length === 0 && itens.emailsCc === 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Informe ao menos um e-mail',
            icon: 'fa-solid fa-circle-exclamation',
            variant: 'danger',
          },
        })
      } else {
        api.notificaSublimite(this.gridProps.row.razaoSocial, itens.emailsPara, itens.emailsCc, this.gridProps.row.id)
        this.emailCc = ''
      }
    },
    openModalHistorico(props) {
      this.$refs[`modalHistorico${props.row.id}`].abrirModal()
    },
    openModalObservacao() {
      this.$refs.modalObservacao.show()
    },
    fecharObservacao(observacaoNova) {
      this.gridProps.row.temObservacoesNaoLidas = observacaoNova.hasObservacaoNova
      this.gridProps.row.todasObservacoesLidas = observacaoNova.observacaoLida
    },
  },
}
</script>
